import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { ConnecttocrudService } from '../connecttocrud.service';
import { ConfService } from '../conf.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AttributeDescriptionComponent } from '../crudapi/crudapi.component';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { KongService } from '../kong.service';
import { LeftpanelComponent } from '../leftpanel/leftpanel.component';
@Component({
    selector: 'app-attributes-list',
    templateUrl: './attributes-list.component.html',
    styleUrls: ['./attributes-list.component.scss']
})
export class AttributesListComponent implements OnInit {
    accept = false;
    attributes: any;
    flagValue = true;
    @Input() tempJSON: any;
    @Input() type: any;
    @Input() rootMapping: any = null;
    @Output() rootMappingValueChanged = new EventEmitter<any>();
    response_types: any = [{ value: 'array<json>', displayValue: 'Array <JSON>' }, { value: 'json', displayValue: 'JSON' }];
    @Input() responseType: any = '';
    @Output() responseTypeValueChanged = new EventEmitter<any>();
    @Input() requestBodySelected: any;
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    options1 = new JsonEditorOptions();
    flag: any;
    httpUrl: string;
    error = false;

    responseCode: any;
    responseData: any;
    responseItems: any;
    responses: any;
    responseObject: any;
    responseError: any;
    responseTimestamp: any;
    responseHeaders: any;
    responseTime: any;

    executor_name: string;
    executor_version: string;
    executor_type = 'API';
    executor_method_type: string;
    executors: any;

    @Input() parameterData = [];
    @Input() pathParameter = [];
    @Input() headersData = [];
    @Input() apiURL: string;
    formData = [];

    errorMessage: any;
    tableLabelName = 'Table Name';
    entityAndVersion: any;
    datatypes: any;
    @Input() httpOperation: any;
    selectedDatatypeFilter: string;
    dataTypeFilter: any;
    databases: any;
    @Input() apiByDefinition: any;
    // @Input() apiByDefinition2: any;
    selectDatabase: string;
    constructor(private _service: ConnecttocrudService, private confPost: ConfService, private kongService: KongService,
        private location: Location,
        private route: ActivatedRoute, public platform: LeftpanelComponent,
        public snackBar: MatSnackBar, private router: Router, private Urlroute: ActivatedRoute, public dialog: MatDialog) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log(/* this.editor.get()*/);
    }

    async ngOnInit() {
        if (this.apiByDefinition) {

        } else {
            this.apiByDefinition = [{
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'array': false,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': 'None',
                'required': false,
                'subType': []

            }];
        }

        // await this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
        //     this.databases = data;
        // });
        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
        } else {
            await this.platform.getDataTypesForPartnerAccount();
            this.datatypes = this.platform.datatypes;
        }

        // this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
        //   this.databases = data;
        // });
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            this.databases = this.platform.databases;
        } else {
            await this.platform.getDatabasesForPartnerAccount();
            this.databases = this.platform.databases;
        }
        // this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
        //     if (response.status === 200) {
        //         this.entityAndVersion = response.body['entityNameAndVersion'];
        //     }
        // });
        if (this.platform.entityAndVersion !== null && this.platform.entityAndVersion !== undefined) {
            this.entityAndVersion = this.platform.entityAndVersion;
        } else {
            await this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
                if (response.status === 200) {
                    this.entityAndVersion = response.body['entityNameAndVersion'];
                    this.platform.entityAndVersion = this.entityAndVersion;
                }
            },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting entity name and version for partner account. Please try after sometime.');
                });
        }
        this.selectDatabase = 'default';
        this.filterDataTypes(this.selectDatabase);
    }
    openAttributeDescriptionDialog(definition) {
        const data = {
            'displayName': definition.displayName,
            'description': definition.description,
            'dataStoragePolicy': definition.dataStoragePolicy,
            'apiAccessPolicy': definition.apiAccessPolicy,
            'displayPolicy': definition.displayPolicy
        };
        const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            this.accept = result;
            definition.displayName = data.displayName;
            definition.description = data.description;
            definition.dataStoragePolicy = data.dataStoragePolicy;
            definition.apiAccessPolicy = data.apiAccessPolicy;
            definition.displayPolicy = data.displayPolicy;
        });
    }
    removeAttribute(data, index) {
        if (confirm('Are you sure you want to remove this attribute?')) {
            data.splice(index, 1);
        }
    }
    setPrimaryFlag(i, type) {
        if (type === 'Primary' && this.flagValue) {
            this.flag = i;
            this.flagValue = false;
        } else if (i === this.flag && !this.flagValue && type !== 'Primary') {
            this.flag = null;
            this.flagValue = true;
        }
    }
    omit_special_char(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode === 8 || charCode === 32 || (charCode >= 48 && charCode <= 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }
    checkNumber(event) {
        let k;
        k = event.charCode;
        return ((k >= 48 && k <= 57));
    }
    getRegion(val) {
        return this.platform.getRegion(val);
    }
    getDatabaseTypeForDatabaseName(val) {
        if (this.databases && this.databases !== null && this.databases !== undefined) {
            this.databases.filter(items => {
                if (items.database_name === val) {
                    this.selectedDatatypeFilter = items.database_type;
                }
            });
        }
    }
    filterDataTypes(val) {

        this.getDatabaseTypeForDatabaseName(val);
        this.dataTypeFilter = [];
        if (this.datatypes && this.datatypes !== null && this.datatypes !== undefined) {
            this.datatypes.filter(items => {
                if (items.database_type === this.selectedDatatypeFilter) {
                    this.dataTypeFilter.push(items);
                }
            });
        }
        if (this.selectedDatatypeFilter === 'mongodb') {
            this.tableLabelName = 'Collection Name';
        } else {
            this.tableLabelName = 'Table Name';
        }
    }
    typeCheck(definition) {

        const entityAndVersionCheckString = definition.type,
            substring = '_';
        if (entityAndVersionCheckString.includes(substring)) {
            definition.customType = true;
            definition.attributeType = 'DBRef';
        } else {
            definition.customType = false;
            definition.attributeType = 'None';
        }

        if (this.selectDatabase === 'default' || this.selectDatabase === 'mongo') {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition.subType, this.selectDatabase);
            } else {
                this.removeAttributeField(definition.subType);
            }
        } else {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition.subType, this.selectDatabase);
            } else {
                this.removeAttributeField(definition.subType);
            }
        }
    }
    removeAttributeField(data) {
        for (var i = 0; i < data.length; i++) {
            data.splice(i, 1);
        }
    }
    stringifyjson(val) {
        return JSON.stringify(val);
    }
    addAttributeField(data, database) {

        if (database === 'mongodb' || database === 'default') {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'array': false,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': []
            };
            data.push(newField);
        } else {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': []
            };
            data.push(newField);
        }
    }
    getRequestBody() {
        // if (this.headersData.hasOwnProperty('Content-Type')){
        //     const index = this.headersData.indexOf('Content-Type', 0);
        //     if (index > -1) {
        //         this.headersData.splice(index, 1);
        //     }
        // }
        if (this.requestBodySelected === 'raw') {
            const requestbody = {
                'value': this.getRequestBodyValue(this.requestBodySelected),
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'form-data') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = {
                'value': '',
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        }

    }
    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                return this.editor.get();
            case 'binary':
            case 'none':
            default:
        }
    }
    getDatRootAttributes(data, prefix = '', attributes = []) {
        if (Array.isArray(data)) {
            data.forEach(item => {
                const attributeName = prefix ? `${prefix}.${item.attributeName}` : item.attributeName;
                attributes.push(attributeName);
                if (item.subType && item.subType.length > 0) {
                    this.getDatRootAttributes(item.subType, attributeName, attributes);
                }
            });
        }
        return attributes;
    }

    emitRootMapping() {
        if (this.type == undefined) {
            this.rootMappingValueChanged.emit(this.rootMapping);
        }
    }

    emitresponseTypeChange() {
        if (this.type == undefined) {
            this.responseTypeValueChanged.emit(this.responseType);
        }
    }

    // executeApiAndLoadResponse() {
    //     this.responseData = '';
    //     this.errorMessage = '';
    //     this.responseError = '';
    //     const payload = {
    //         'executor_name': this.executor_name,
    //         'executor_type': this.executor_type !== null ? this.executor_type : 'API',
    //         'executor_version': this.executor_version,
    //         'executor_method_type': this.httpOperation,
    //         'apiUrl': this.apiURL,
    //         'queryParams': this.parameterData,
    //         'pathParams': this.pathParameter,
    //         'headers': this.headersData,
    //         'authModel': null,
    //         'requestBody': this.getRequestBody(),
    //         'executors': this.executors,
    //     };
    //
    //     this.confPost.getResponseAttribute(localStorage.getItem('partner'), localStorage.getItem('account'), payload).subscribe(response => {
    //         this.apiByDefinition = response;
    //     });
    //     // this._service.(payload).subscribe(response => {
    //     //         this.responses = response;
    //     //         this.responseItems = this.responses.body;
    //     //         let returnObject = JSON.parse(this.responseItems.body);
    //     //     },
    //     //     error => {
    //     //         if (error.error.message) {
    //     //             // Need to revisit this part later
    //     //             if (error.error.message.substring(error.error.message.lastIndexOf('{'), error.error.message.indexOf('}') + 1)) {
    //     //                 this.responseObject = JSON.parse(error.error.message.substring(error.error.message.lastIndexOf('{'), error.error.message.indexOf('}') + 1));
    //     //                 this.responseCode = this.responseObject.status;
    //     //                 this.errorMessage = this.responseObject.message;
    //     //                 this.responseError = this.responseObject.error;
    //     //                 this.responseTimestamp = this.responseObject.timestamp;
    //     //             } else {
    //     //                 this.responseCode = error.error.status;
    //     //                 this.errorMessage = error.error.message;
    //     //                 this.responseError = 'Internal Server Error';
    //     //             }
    //     //         } else {
    //     //             this.responseCode = 500;
    //     //             this.errorMessage = 'Error while processing your request. Please check the headers and query parameters that may be missing in your request.';
    //     //             this.responseError = 'Internal Server Error';
    //     //         }
    //     //         this.error = true;
    //     //     }
    //     // );
    // }
}

// @Component({
//     selector: 'deploy-as-api',
//     templateUrl: './deploy-as-api.component.html',
//     styleUrls: ['./deploy-as-api.component.css']
// })
// export class DeployAsApiComponent {
//     executor_type: string;
//     executor_name: string;
//     executor_version: string;
//     executor_display_name: string;
//     executor_description: string;
//     executor_category: string;
//     executor_category_group: string;
//     executor_scope: string;
//     executor_method_type: string;
//     executorMethods = [
//         {name: 'GET'},
//         {name: 'POST'},
//         {name: 'PUT'},
//         {name: 'DELETE'}
//     ];
//
//     executorTypes = [
//         // {'displayName': 'Generic API', 'value': 'API'},
//         // {'displayName': 'Business Logic API', 'value': 'BUSINESSLOGIC'},
//         // {'displayName': 'Data Access API', 'value': 'API'},
//         // {'displayName': 'Data Access API', 'value': 'DATAACCESS'},
//         {'displayName': 'Third Party API', 'value': 'THIRDPARTY'}];
//
//     scope = [{'displayName': 'Public', 'value': 'public'},
//         {'displayName': 'Private', 'value': 'private'}];
//     filteredOptions: Observable<ICategory[]>;
//     myControl = new FormControl();
//     constructor(
//         private confPost: ConfService, private snackBar: MatSnackBar,
//         public dialogRef: MatDialogRef<DeployAsApiComponent>,
//         @Inject(MAT_DIALOG_DATA) public data: any) {
//     }
//
//     onNoClick(): void {
//         this.dialogRef.close();
//     }
//     displayFn(user?: ICategory): string | undefined {
//         return user ? user.name : undefined;
//     }
//
// }
